<template>
  <div class="header-filter py-3">
    <v-layout wrap>
      <v-flex xs12 md3>
        <SelectCreditors
          :multiple="false"
          :clearable="false"
          :negotiation="true"
          :selected="selectedCreditor"
          :disabled="loading"
          hide-details
          @selectedCreditors="$emit('selected-creditors', $event)"
        ></SelectCreditors>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          box
          flat
          success
          clearable
          hide-details
          item-value="id"
          item-text="name"
          no-data-text="Sem dados"
          class="text-details-none"
          label="Estruturas de árvore"
          :items="orderDebtBases"
          :disabled="loading || !selectedCreditor"
          :value="selectedBaseId"
          @input="$emit('change-selected-base-id', $event)"
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-tile-content v-on="on" v-bind="attrs">
              <div style="display: flex; width: 100%">
                <span
                  class="ma-auto"
                  :class="
                    item.id == selectedBaseId
                      ? 'primary--text'
                      : item.status == 'ARCHIVED'
                      ? 'grey--text'
                      : ''
                  "
                >
                  {{ item.name }}
                </span>
                <v-spacer></v-spacer>
                <div
                  :class="
                    item.id == selectedBaseId
                      ? 'deep-purple lighten-5'
                      : setSelectTree(item.status, 'background')
                  "
                  style="border-radius: 50%; padding: 3px; height: 30px"
                >
                  <v-icon
                    :color="
                      item.id == selectedBaseId
                        ? 'primary'
                        : setSelectTree(item.status, 'color')
                    "
                  >
                    {{ setSelectTree(item.status, "icom") }}
                  </v-icon>
                </div>
              </div>
            </v-list-tile-content>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 md6>
        <v-switch
          :input-value="stimulusActive"
          label="Mostrar Arquivados"
          hide-details
          @change="$emit('change-stimulus-active', $event)"
        />
      </v-flex>
    </v-layout>
    <div class="header-actions">
      <div class="actions-group">
        <v-checkbox
          :input-value="selectAllCheckbox"
          hide-details
          class="my-0 py-0 pr-3"
          label="Selecionar Todos"
          @change="$emit('change-select-all-checkbox', $event)"
        />

        <v-btn
          color="accent"
          style="border-radius: 5px"
          :disabled="loading || !selectedStimulusLength || hasActiveSelected"
          @click="$emit('open-dialogs-dates', hasActiveSelected)"
        >
          <v-icon left class="mr-1">mdi-play</v-icon>
          Ativar
        </v-btn>
        <v-btn
          color="accent"
          style="border-radius: 5px"
          :disabled="loading || !selectedStimulusLength || !hasActiveSelected"
          @click="$emit('open-dialogs-dates', hasActiveSelected)"
        >
          <v-icon left class="mr-1">mdi-stop</v-icon>
          Desativar
        </v-btn>
        <v-btn
          color="accent"
          style="border-radius: 5px"
          :disabled="loading || !selectedStimulusLength"
          @click="$emit('open-multiple-dialog-archiving-stimulus')"
        >
          <v-icon left class="mr-1">{{
            stimulusActive ? "mdi-archive-arrow-up" : "mdi-archive-arrow-down"
          }}</v-icon>
          {{ stimulusActive ? "Desarquivar" : "Arquivar" }}
        </v-btn>
        <v-btn
          color="accent"
          style="border-radius: 5px"
          :disabled="loading || !selectedStimulusLength || !hasActiveSelected"
          @click="$emit('prepare-stimulus')"
        >
          <v-icon left class="mr-1">mdi-check-all</v-icon>
          Preparar Estímulos Selecionados
        </v-btn>
      </div>
      <v-tooltip bottom :disabled="loading || !selectedStimulusLength">
        <v-btn
          slot="activator"
          flat
          icon
          large
          class="my-0 py-0"
          color="accent"
          :disabled="loading || !selectedStimulusLength"
          @click="$emit('clear-selection')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        Limpar seleção
      </v-tooltip>
    </div>
    <div class="caption grey--text text--darken-1 pl-1">
      <span class="selection-count">
        {{ selectedStimulusLength }} selecionado{{
          selectedStimulusLength !== 1 ? "s" : ""
        }}
      </span>
    </div>
  </div>
</template>

<script>
import SelectCreditors from "@/components/creditor/SelectCreditors";

export default {
  name: "StimulusHeader",
  components: {
    SelectCreditors,
  },
  props: {
    hasActiveSelected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    orderDebtBases: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectAllCheckbox: {
      type: Boolean,
      default: false,
    },
    selectedBaseId: {
      type: Number,
      default: null,
    },
    selectedCreditor: {
      type: Number,
      default: 0,
    },
    selectedStimulusLength: {
      type: Number,
      default: 0,
    },
    setSelectTree: {
      type: Function,
      default: function () {
        return "";
      },
    },
    stimulusActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css" scoped>
.header-filter {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.actions-group {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
</style>
